var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 66,
    viewBox: "0 0 70 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160526",
    "data-name": "Group 160526",
    transform: "translate(-1370 -212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147638",
    "data-name": "Rectangle 147638",
    transform: "translate(1370 212)",
    fill: "#f5f7f8",
    stroke: "rgba(112,112,112,0.18)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 66,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 65,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-circle",
    "data-name": "Icon feather-alert-circle",
    transform: "translate(1387 227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37544",
    "data-name": "Path 37544",
    d: "M33,18A15,15,0,1,1,18,3,15,15,0,0,1,33,18Z",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37545",
    "data-name": "Path 37545",
    d: "M18,12v6",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37546",
    "data-name": "Path 37546",
    d: "M18,24h0",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.72fa5f19f91eefcc59aee6b408e0c5be.svg";
export { ForwardRef as ReactComponent };